import epsClient from 'enrollment-platform/api/eps.client'
import { type SurecoCsvDataType } from '../constants'

// Shared across every plan-management-v2 upload surface (Health Plan tab,
// Compare Data tab, ...) that auto-detects a CSV's data type from its
// header row instead of asking the user to pick one. `headerLine` is just
// the raw first line of the file, read client-side — the file itself is
// never uploaded here.
export interface DetectPlanManagementDataTypeResultDto {
  matched: boolean
  dataType: SurecoCsvDataType | null
  success: boolean | null
  columnErrors: string[]
}

export async function detectPlanManagementDataType(
  headerLine: string
): Promise<DetectPlanManagementDataTypeResultDto> {
  const { data } = await epsClient.post<DetectPlanManagementDataTypeResultDto>(
    '/api/v1/plan-management-v2/detect-data-type',
    { headerLine }
  )
  return data
}
